import { render, staticRenderFns } from "./LeftNavigation.vue?vue&type=template&id=065c0530&scoped=true"
import script from "./LeftNavigation.vue?vue&type=script&lang=js"
export * from "./LeftNavigation.vue?vue&type=script&lang=js"
import style0 from "./LeftNavigation.vue?vue&type=style&index=0&id=065c0530&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065c0530",
  null
  
)

export default component.exports